import request, { serviceV2 } from '@/utils/request'

const prefix = '/django_rest/interview'
const aiInterviewPrefix = '/ai-interview'
const interviewV2Prefix = '/interview'

export default {
  resendInvitation (invitationInfo) {
    return request.post(`${prefix}/invite/resend/invitation/`, invitationInfo)
  },
  getCoachAIInterviewInfo (params) {
    return request.get(`/django_rest/coach-ai-interview/record-management/${params.candidate_id}/`, { params })
  },
  updateCoachAIInterviewAnswer (candidateId, answerInfo) {
    return request.post(`/django_rest/coach-ai-interview/record-management/${candidateId}/upload/`, answerInfo)
  },
  getInterviewInvitationRecordInfo (params) {
    return request.get(`${prefix}/invitation-record/`, { params })
  },
  getRateRecordList (params) {
    return request.get('/django_rest/rate-management/', { params })
  },
  getInterviewQuestionTemplateInfo (params) {
    return request.get('/django_rest/company/interview-question/', { params })
  },
  moveInterviewQuestionTemplate (data) {
    return request.put('/django_rest/company/interview-question/move/', data)
  },
  updateInterviewQuestionTemplate (questionId, data) {
    return request.put(`/django_rest/company/interview-question/${questionId}`, data)
  },
  saveInterviewQuestionTemplate (data) {
    return request.post('/django_rest/company/interview-question/', data)
  },
  getInterviewQuestionCategoryInfo (params) {
    return request.get('/django_rest/company/interview-question/category/', { params })
  },
  updateInterviewQuestionCategory (categoryId, data) {
    return request.put(`/django_rest/company/interview-question/category/${categoryId}`, data)
  },
  saveInterviewQuestionCategory (data) {
    return request.post('/django_rest/company/interview-question/category/', data)
  },
  getAIInterviewRoomList (companyId) {
    return serviceV2.get(`${aiInterviewPrefix}/company/${companyId}/interview-rooms/`)
  },
  getJobInterviewRoomInfo (jobId) {
    return serviceV2.get(`${aiInterviewPrefix}/job/${jobId}/interview-room/`)
  },
  createOrUpdateJobAIInterviewRoom (data) {
    return serviceV2.post(`${aiInterviewPrefix}/job/${data.job_id}/interview-room/`, data)
  },
  inviteAIInterview (data) {
    return serviceV2.post(`${aiInterviewPrefix}/company/${data.company_id}/job/${data.job_id}/invite-interview/`, data)
  },
  remindAIInterview (data) {
    return serviceV2.post(`${aiInterviewPrefix}/company/${data.company_id}/job/${data.job_id}/candidate/${data.candidate_id}/remind-interview/`, data)
  },
  getAIInterviewRecordInfo (params) {
    return serviceV2.get(`${aiInterviewPrefix}/company/job/${params.job_id}/candidate/${params.candidate_id}/interview-info/`, { params })
  },
  getHrInterviewQuestionnaireResults (params) {
    return serviceV2.get(`/hr/application/job/${params.job_id}/candidate/${params.candidate_id}/interview-questionnaire-results/`)
  },
  getCompanyAIInterviewConfig () {
    return serviceV2.get(`${aiInterviewPrefix}/service-config/`)
  },
  createOrUpdateAIInterviewConfig (data) {
    return serviceV2.post(`${aiInterviewPrefix}/service-config/`, data)
  },
  getHmInterviewScheduleList (data) {
    return serviceV2.post(`${interviewV2Prefix}/hm-schedule/`, data)
  },
  sendInterviewInvitation (data) {
    return serviceV2.post(`${interviewV2Prefix}/invite/`, data)
  },
  editInvitation (data) {
    return serviceV2.put(`${interviewV2Prefix}/invite/`, data)
  },
  getInterviewCriteriaList (params) {
    return serviceV2.get(`${interviewV2Prefix}/criteria-question/`, { params })
  },
  searchInterviewRecordList (params) {
    return serviceV2.get(`${interviewV2Prefix}/record/list/`, { params })
  },
  getInterviewRecordInfo (interviewUuid, params) {
    return serviceV2.get(`${interviewV2Prefix}/record/${interviewUuid}/`, { params })
  },
  updateInterviewRecordInfo (interviewUuid, data) {
    return serviceV2.post(`${interviewV2Prefix}/record/${interviewUuid}/operation/`, data)
  },
  updateInterviewRecordOnlineInfo (interviewUuid, data) {
    return serviceV2.post(`${interviewV2Prefix}/record/${interviewUuid}/update-online-info/`, data)
  },
  previewInterviewEmailInfo (params) {
    return serviceV2.post(`${interviewV2Prefix}/preview-email/`, params)
  },
  getInterviewManagementDashboardInfo (params) {
    return serviceV2.get(`${interviewV2Prefix}/dashboard/`, { params })
  },
  resendInvitationRatingLink (invitationInfo) {
    return serviceV2.post(`${interviewV2Prefix}/resend-rating-link/`, invitationInfo)
  }
}
